import { useEffect, useState } from "react";
import GenderPie from "../components/GenderPie";
import AgeBar from "../components/AgeBar";
import StatCard from "../components/StatCard";
import FilterGender from "../components/FilterGender";

const EMPTY = {
  summary: {
    total: 0,
    female: { count: 0, percent: 0 },
    male: { count: 0, percent: 0 },
    unknown: { count: 0, percent: 0 }
  },
  gender_pie: [],
  age_distribution: [],
  filter_stats: { filtered_total: 0 },
  insight: null
};

export default function Customer() {
  const [data, setData] = useState(EMPTY);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/dashboard/customer-demographic")
      .then(res => res.json())
      .then(json => setData(json.data || EMPTY))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="p-6">Loading...</div>;

  return (
    <div className="p-6 space-y-6 bg-gray-50 min-h-screen">

      {/* Filter */}
      <FilterGender />

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <StatCard title="ลูกค้าทั้งหมด" value={data.summary.total} />
        <StatCard title="ผู้หญิง" value={data.summary.female.count} sub={`${data.summary.female.percent}%`} />
        <StatCard title="ผู้ชาย" value={data.summary.male.count} sub={`${data.summary.male.percent}%`} />
        <StatCard title="ข้อมูลที่กรอง" value={data.filter_stats.filtered_total} />
      </div>

      {/* Charts */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <GenderPie data={data.gender_pie} />
        <AgeBar data={data.age_distribution} />
      </div>

      {/* Insight */}
      <div className="bg-white rounded-xl p-6 shadow">
        <h3 className="font-semibold mb-2">สรุปข้อมูล</h3>
        {data.insight && (
          <ul className="text-sm text-gray-600 space-y-1">
            <li>📊 เพศที่มีจำนวนมากที่สุด: {data.insight.top_gender.label} ({data.insight.top_gender.count} คน)</li>
            <li>📈 ช่วงอายุที่มากที่สุด: {data.insight.top_age_range.label} ({data.insight.top_age_range.count} คน)</li>
            <li>💡 คำแนะนำ: {data.insight.recommendation}</li>
          </ul>
        )}
      </div>

    </div>
  );
}
